// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"_h-z","subtitle":"ai-z","wrapper":"bi-z","leftArrow":"ci-z","rightArrow":"di-z"};